var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "motivation-info"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "all-windows"
  }, [_c('div', {
    staticClass: "front-window transformed-left"
  }, [_c('div', {
    staticClass: "image-wrapper"
  }, [_c('image-placeholder')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "front-window transformed-right"
  }, [_c('div', {
    staticClass: "image-wrapper"
  }, [_c('image-placeholder')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "front-window"
  }, [_c('div', {
    staticClass: "image-wrapper"
  }, [_c('image-placeholder')], 1)])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-message"
  }, [_c('h2', [_vm._v("Why Modus Versus?")]), _vm._v("\n    Capacitance cascading integer reflective interface data development high bus cache dithering transponder.\n  ")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b16b8686","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/motivation-info/motivation-info.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-b16b8686","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/extract-loader/lib/extractLoader.js!./node_modules/html-loader/index.js?{"interpolate":true,"attrs":[":url","link:href","source:src"]}!./src/components/motivation-info/motivation-info.vue
// module chunks = index